//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import { withRouter } from 'react-router';
import { Switch, Route, Redirect } from 'react-router-dom';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
// import styles from './App.scss';
// import * as styles from './App.module.scss';
import * as styles from './App.module.scss';
// import styles from './App.scss';

//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import {
  About,
  Dashboard,
  Docs,
  DocsPage,
  Welcome,
  Callback,
  Registration,
  Profile,
  RewardSelection,
  Support,
  TermsConditions,
  AfterWelcome
} from '@cmp/client';
import { FooterSection } from '@cmp/common';
import {
  ProfessionalCode,
  ProfessionalCodeShare,
  ProfessionalCodeSuccess,
} from './client/dashboard/client/';

import { ErrorBoundary, PrivateRoute } from '@cmp/common';
import { withAuthUser } from '@helpers/auth';
import { withModal } from '@helpers/modal';
import { withTranslation } from 'react-i18next';
import {
  completedRegistration,
  checkReferralAndAuthorize,
} from '@helpers/account';
import { checkTouchCapabilities } from '@helpers/device';
import { ProfileKindInfo } from '@helpers/profileKind';
import { gtmCode } from '@helpers/gtm';
import { dynatraceInjection } from '@helpers/dynatraceInjection';
//------------------------------------------------------------------------------
// API -------------------------------------------------------------------------
import { StoreConfigProvider } from '@api/endpoints/get/storeConfigProvider';
import { t } from 'i18next';
import { FilterProvider } from './client/dashboard/client/filters/context';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------

const routeComponentMap = {
  '/recommendation/professional-code': ProfessionalCode,
  '/recommendation/professional-code-share': ProfessionalCodeShare,
  '/recommendation/professional-code-success': ProfessionalCodeSuccess,
  '/after-welcome': AfterWelcome,
  '/about': About,
  '/': Dashboard,
  '/support': Support,
  '/terms-and-conditions': TermsConditions,
};

function isSafari() {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('safari') != -1) {
    if (ua.indexOf('chrome') < 0) {
      return true;
    }
  }
  return false;
}

const ModalComponent = (props) => {
  const { history = {}, location = {} } = props;

  const Modal = routeComponentMap[location.pathname];
  if (!Modal) return null;

  return <Modal history={history} location={location} />;
};

const ModalOverlay = (location = {}) => {
  const previousPathname = location?.state?.from?.pathname;

  const Overlay = routeComponentMap[previousPathname];

  return Overlay || Dashboard;
};
class App extends React.Component {
  componentDidMount() {
    checkTouchCapabilities();
    gtmCode(t);
    dynatraceInjection(t);
  }

  componentWillMount() {
    checkReferralAndAuthorize();
  }

  render() {
    const { __authUser, t, history, location, isModal } = this.props;
    const componentClasses = classNames(styles.App, {
      [styles.WithSafari]: isSafari(),
    });

    return (
      <div className={componentClasses}>
        <Helmet
          titleTemplate={`%s | ${t('header_title')}`}
          defaultTitle={`${t('header_title')} - ${t(
            'header_MakeRecommendationsReality'
          )}`}
        />

        <ErrorBoundary>
          <StoreConfigProvider>
            <FilterProvider>
              <Switch>
                {/* Set up basic routes */}
                <Route
                  path="/terms-of-service"
                  render={(props) => <Docs page={DocsPage.TERMS_OF_SERVICE} />}
                />
                <Route
                  path="/privacy-policy"
                  render={(props) => <Docs page={DocsPage.PRIVACY_POLICY} />}
                />
                <Route path="/about" component={About} />
                <Route
                  path="/terms-and-conditions"
                  component={TermsConditions}
                />
                <Route path="/support" component={Support} />
                {/* Expose the profile route for both authenticated and
                unauthenticated users */}
                <Route
                  exact
                  path="/myaccount"
                  render={(props) => (
                    <Profile
                      {...props}
                      kind={ProfileKindInfo(t, 'PersonalInfo')}
                    />
                  )}
                />
                <Route
                  exact
                  path="/myaccount/update-reward-selection"
                  render={(props) => <RewardSelection {...props} />}
                />
                <Route
                  exact
                  path="/myaccount/password"
                  render={(props) => (
                    <Profile {...props} kind={ProfileKindInfo(t, 'Password')} />
                  )}
                />
                {/* Set up registration pages in case the user hasn't completed
                their profile or hasn't verified their email */}
                <Route path="/registration" component={Registration} />
                {__authUser && !completedRegistration(__authUser) && (
                  <Route path="/" component={Callback} />
                )}
                {/* Finally, present either the dashboard or the welcome (landing,
                sign in...) based on authentication status */}
                <PrivateRoute
                  path="/"
                  component={isModal ? ModalOverlay(location) : Dashboard}
                  publicComponent={Welcome}
                />
                <Redirect from="*" to="/" />
              </Switch>
              {isModal ? (
                <Route exact path={location.pathname}>
                  <ModalComponent history={history} location={location} />
                </Route>
              ) : null}

              <FooterSection />
            </FilterProvider>
          </StoreConfigProvider>
        </ErrorBoundary>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withRouter(withModal(withAuthUser(withTranslation()(App))));
